import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    EUCIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={EUCIconImg} preview={false}/>
